import { Box, Stack, TextField, Typography } from '@chronosphereio/chrono-ui';
import { useEffect, useRef, useState } from 'react';
import ReactVirtualizedAutoSizer from 'react-virtualized-auto-sizer';
import { ContextLinkDefinition } from '../../../core';
import { LinkEditorType } from './ContextLinkEditor';
import { VariablesTable } from './VariablesTable';

const GenericLinkEditorFormContent: LinkEditorType<{ width: number }> = ({
  initialLink,
  Controls,
  width,
  contextLinkConfig,
}) => {
  const [title, setTitle] = useState(initialLink?.spec.title || '');
  const [url, setUrl] = useState(initialLink?.spec.url || '');
  const inputRef = useRef<HTMLInputElement>();

  const getLink = () => {
    return {
      kind: 'ContextLink',
      spec: {
        title,
        url,
      },
    } as ContextLinkDefinition;
  };
  const isValid = title.length > 0 && url.length > 0;

  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  return (
    <Box width={width}>
      <Stack spacing={1}>
        <TextField
          inputRef={inputRef}
          required
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          label="Name"
          sx={{ width: width > 500 ? '25%' : '100%' }}
          placeholder="Name"
        />
        <TextField
          required
          value={url}
          onChange={(e) => setUrl(e.target.value)}
          label="URL"
          fullWidth
          placeholder="https://example.com/${env}?start=${__start_time}"
        />
        <Stack spacing={1} direction="row">
          <Controls getLink={getLink} isValid={isValid} />
        </Stack>
      </Stack>

      <Box mt={2}>
        <Typography variant="h4">Variables</Typography>
        <Typography variant="body2" mb={1}>
          The following variables are available to use in the URL:
        </Typography>
        <VariablesTable contextLinkConfig={contextLinkConfig} />
      </Box>
    </Box>
  );
};

export const GenericLinkEditorForm: LinkEditorType = ({ initialLink, Controls, contextLinkConfig }) => {
  return (
    <ReactVirtualizedAutoSizer disableHeight>
      {({ width }) => (
        <GenericLinkEditorFormContent
          initialLink={initialLink}
          Controls={Controls}
          contextLinkConfig={contextLinkConfig}
          width={width}
        />
      )}
    </ReactVirtualizedAutoSizer>
  );
};
